import React from 'react';

import {
  Container,
  List,
  Panel,
  TabButton,
  TabsSize,
  TabsVariant,
} from './styles';

export type TabItem = {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
  panel?: React.ReactNode;
};

export type TabsProps = {
  items: TabItem[];
  value: string;
  onChange: (value: string) => void;
  variant?: TabsVariant;
  size?: TabsSize;
  fullWidth?: boolean;
  color?: string;
  activeColor?: string;
  activeBackgroundColor?: string;
  borderColor?: string;
  className?: string;
};

const Tabs = ({
  items,
  value,
  onChange,
  variant = 'pill',
  size = 'md',
  fullWidth = false,
  color,
  activeColor,
  activeBackgroundColor,
  borderColor,
  className,
}: TabsProps): JSX.Element => {
  const activeItem = items.find((item) => item.value === value);

  return (
    <Container $fullWidth={fullWidth} className={className}>
      <List
        role="tablist"
        $variant={variant}
        $fullWidth={fullWidth}
        $borderColor={borderColor}
      >
        {items.map((item) => {
          const isActive = item.value === value;

          return (
            <TabButton
              key={item.value}
              type="button"
              role="tab"
              aria-selected={isActive}
              disabled={item.disabled}
              $variant={variant}
              $size={size}
              $active={isActive}
              $disabled={item.disabled}
              $color={color}
              $activeColor={activeColor}
              $activeBackgroundColor={activeBackgroundColor}
              $borderColor={borderColor}
              onClick={() => {
                if (!item.disabled) onChange(item.value);
              }}
            >
              {item.label}
            </TabButton>
          );
        })}
      </List>

      {activeItem?.panel !== undefined && (
        <Panel role="tabpanel">{activeItem.panel}</Panel>
      )}
    </Container>
  );
};

export default Tabs;
